
<template>

    <div>    

      <not-allowed v-if="allowed.success===false" :data="allowed"/>

    <!-- permet de modifier le nom et nom de clé du template actif-->
    <v-dialog v-model="dialogTemplate" width="800"
            @click:outside="closeDial">
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                Modification du template 
                <v-spacer></v-spacer>
                <v-btn icon @click="closeDial"><v-icon>mdi-close-thick</v-icon></v-btn>      
                </v-card-title>

                <v-card-text v-if="indexTemplate !==false">

                    <TextField 
                    :keyup="(item,value) => { template[indexTemplate].name = value }"
                    :valField="template[indexTemplate].name"
                    :item="{name:'Nom du template',value:'name',defaultprops:{show:true}}"
                    /> 
                    <TextField 
                    v-if="indexTemplate"
                    :keyup="(item,value) => { template[indexTemplate].key = value }"
                    :valField="template[indexTemplate].key"
                    :item="{name:'Clé',value:'key',defaultprops:{show:true}}"
                    />  

                    l'élément sera affiché si toutes les conditions sont remplis)

                    <groupConditions v-if="indexTemplate" :conditions="template[indexTemplate].conditions" @recepVal="(array) => { template[indexTemplate].conditions = array }" />

                </v-card-text>

            </v-card>
            </v-dialog>


            <div v-if="activeTemplate && !isEmbedded" class="page-header-tools">
              <rights-indicator :checks="pageInspectionChecks" label="Accès à cette page" />
              <div v-if="$store.getters.currentUser.type==3" class="page-template-toolbar">
                  <v-switch
                      v-model="ModifTemplate"
                      dense
                      class="page-template-toolbar__switch ma-0 pa-0"
                      hide-details
                      aria-label="Modifier le template"
                      title="Modifier le template"
                  ></v-switch>
                  <span class="page-template-toolbar__variant">Variante {{variantPage}}</span>
                  <span aria-hidden="true">&middot;</span>
                  <b class="page-template-toolbar__name" :title="activeTemplate.name">{{activeTemplate.name}}</b>
              </div>
              <v-btn v-if="$store.getters.currentUser.type==3" icon x-small title="Voir cette page dans le pilotage système" aria-label="Voir cette page dans le dashboard"
                :to="{name:'engine-dashboard',query:{tab:'catalog',metier:$store.getters.currentUser.metier,element_type:'page',element_id:String(page)}}">
                <v-icon size="16">mdi-view-dashboard-outline</v-icon>
              </v-btn>
              <ChatShareMenu v-if="!ModifTemplate" class="chat-page-share" :hover-only="false" :modal-key="modalKey" :reference="{type:'page',page_id:page}" label="Partager cette page dans le chat" />
            </div>

            <v-container
            v-if="activeTemplate"
            :class="paramsPage.class"
            :fluid="paramsPage.containerfluid"
            :id="paramsPage.containerid"
            class="chat-page-host"
            >




         

                <!-- intégration des ventilation de cette page si il n'y a aucun crochet-->
                <component v-if="!isEmbedded" v-bind:is="$modules.ventilation.components.client" :page="page" :modal="modal" :modalKey="modalKey" :hook="hook" :form="$refs['form-'+modalKey]"/>

                <v-row v-if="ModifTemplate">    
                    <v-col class="col-12">
                        <List v-if="ModifTemplate && (!hook || hook=='search' || hook=='tabs')" :page="page" :modalKey="modalKey" :modal="modal" :template="template" @manageTemplate="manageTemplate" :selected="activeTemplate" :form="$refs['form-'+modalKey]"/> 
                    </v-col>            
                    <v-col class="col-12 text-center">
                        <v-btn @click="savePage()" :loading="savingTemplate" :disabled="savingTemplate" class="blue" dark x-small><v-icon x-small>mdi-content-save</v-icon> Enregistrer le template</v-btn>
                        <v-btn class="blue" dark x-small @click="editPageRights">
                        <v-icon small>mdi-eye-outline</v-icon>
                        Droits
                        </v-btn> 
                    </v-col>
                </v-row>
            <v-row v-if="editTemplate!==false">
                <v-col class="text-center">
                    <v-alert outlined color="red">
                        Vous êtes en mode edition du template {{ selectedTemplate.name }}
                    <v-btn @click="savePage(true)" :loading="savingTemplate" :disabled="savingTemplate" class="red" dark x-small><v-icon x-small>mdi-close-box</v-icon>Sauvegarder et sortir</v-btn>
                    </v-alert>
                </v-col>
            </v-row>

            <v-form
            :ref="'form-'+modalKey"
            v-model="modelForm"
            lazy-validation
            v-if="typeform"
            >

            <v-row v-if="showFormCrud.visu" no-gutters>
                <v-col class="text-center">
                    <v-btn color="secondary" icon @click="expandFormLogs = !expandFormLogs">
                    <v-icon>mdi-eye-refresh</v-icon>
                    </v-btn>
                <formLogs :table="showFormCrud.table" :id="showFormCrud.id" :page="page" :modal="modal" :hook="hook" v-if="expandFormLogs"></formLogs>
                </v-col>
            </v-row>
              <CPage 
              :pageTemplate="selectedTemplate.template" 
              :page="page" 
              :modal="modal" 
              :modalKey="modalKey"
              :form="$refs['form-'+modalKey]" 
              :hook="hook"
              @sendDatas="getActionFromTemplate"
              :customparams="params"
              :customquerys="querys"
              :mod="ModifTemplate"
              @recepVal="recupTemplate"
              @ready="recordPageView"
              />
              
            </v-form>

            <CPage 
            v-else
              :pageTemplate="selectedTemplate.template" 
              :page="page" 
              :modal="modal" 
              :modalKey="modalKey"
              :hook="hook"
              :customparams="params"
              @sendDatas="getActionFromTemplate"
              :customquerys="querys"
              :mod="ModifTemplate"
              @recepVal="recupTemplate"
              @ready="recordPageView"
              />

          </v-container>


            <v-container>
              <transition name="custom-fade">
                <v-overlay color="white" v-if="!selectedTemplate && !findError" :value="true" absolute opacity="1">
                    <v-row>
                        <v-col class="blue--text col-12">
                            Chargement de la page
                            <v-progress-linear
                            indeterminate
                            :width="5"
                            ></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-overlay>
              </transition>
            </v-container>

  
        </div> 

</template>

<script>
// on va récupérer les informations de la page et les envoyer dans page ou form

import cond from "../../../mixins/visuelConditions";
import { openRightsEditor } from '@/components/engine/editDroits/navigation'
import ChatShareMenu from '@/components/chat/ChatShareMenu.vue'
import { disposeResourceContext } from '@/components/chat/resources'
import { registerGuidePageContext, updateGuidePageContext } from '@/components/engine/guide/pageContexts'
import { observePageUsage, usageViewId } from '@/components/dashboard/usageTracking'


  export default {
      name : 'MainComponent',
        // independant : provient de pages loadé à la volée. serv uniquement pour les formulaire.
        //si indépendant = true lors du l'enregistrement du form, ca va prendre l'url de la page en question
        props: ['independant','typeform','page','modal','hook','customparams','customquerys','parentModalKey','embedded','resolvedPage'],
        inject: { chatResourceEmbedded: { default: false } },

        mixins : [cond],
        
        components : {
          ChatShareMenu,

          List    : () => import('./page/listElem.vue'), 
          CPage    : () => import('../../engine/outils/constructPage/Page.vue'),
          TextField : () => import('../../fields/textfield.vue'),
          groupConditions : () => import('../../engine/outils/constructConditions/Conditions.vue'),
          formLogs : () => import('../../engine/Logs/crudLogs.vue'),

        },


        data: function() {
            return {
   
              params : {},
              querys : {},           
              modalKey : this.randomKey(6),
              //permet de voir si l'utilisateur a le droit de visu sur la page
              allowed : {message:'',success:''},
              // ouvre le dialog de condition du template
              dialogTemplate : false,
              //template en cours de visu
              selectedTemplate : false,
              // regarde si le retour API de la page n'a pas eu d'erreur php
              findError : false,
              //a voir :
              indexTemplate : false,
              //liste destemplate de page en attente de réception
              template : [],
              variantPage : 0,
              //int (index) : permet de selectionner le template à modifier via la liste des templates ds params page
              editTemplate : false,
              //bool : permet de lancer le mode de construction du template
              ModifTemplate : false,
              savingTemplate : false,

              //modele de la balise pour le formulaire
              modelForm : true,
              //peremt de visualiser les logs pour les form
              expandFormLogs : false,
              //montre si l'utilisateur peut voir ou pas les logs du form en fonction de ses droits
              showFormCrud : {visu : false, id:0,table:''},

              paramsPage : {}

            }
        },

        titleBrowser () {
        if (this.isEmbedded) return null
        return this.replaceBy({text:this.paramsPage.displayname,page:this.modalKey})
        },


        computed : {
          pageInspectionChecks() {
            if (!/^[1-9]\d*$/.test(String(this.page))) return []
            const context = this.$store.getters.specificPage(this.modalKey) || {}
            const checks = [{ core: 'page', id: this.page, label: 'Visibilité de la page' }]
            if (context.table && /^[a-zA-Z][a-zA-Z0-9_]*$/.test(context.table)) checks.push({ core: 'table_' + context.table, id: 'watch', label: 'Consultation des données' })
            return checks
          },
          isEmbedded() { return Boolean(this.embedded || this.chatResourceEmbedded) },
          guidePageSelection() {
            const selected = this.selectedTemplate
            const key = selected && typeof selected.key === 'string' ? selected.key : null
            return {
              pageId: this.page,
              variant: this.variantPage,
              templateKey: key,
              templateName: selected && selected.name || '',
              templateAmbiguous: !key || this.template.filter(template => template.key === key).length !== 1,
              selected: !!selected,
              embedded: this.isEmbedded,
              editing: this.ModifTemplate || this.editTemplate !== false,
            }
          },
          isValidateForm() {
              return (this.$store.getters.listForm(this.modalKey)) ? this.$store.getters.listForm(this.modalKey)['validate'] : false;
          },

            activeTemplate() {
                // ⚠️ Pour rendre réactif, on force Vue à "écouter" les valeurs du store utilisées
               // const storeState = this.$store.state; // rend toutes les props du store observables ici
                const templates = this.template || [];

                if (!templates.length) return null;

                // si on est en mode édition
                if (this.editTemplate !== false) {
                return templates[this.editTemplate];
                }

                // sinon on vérifie les conditions pour chaque template
                const hit = templates.find((templ, i) => {
                if (i === 0) return false; // 0 = défaut
                const res = this.visuelConditions(templ.conditions);
                return res.length && res.every(v => v === true);
                });

                return hit || templates[0];
            }
          
        },

        watch : {
            //permet de sortir automatiquement du mode construction du template lors de la désactiv de modif template
            ModifTemplate(val) {
                if(!val) this.editTemplate = false
                if(!val) this.recordPageView()
            },

            modelForm(val) {
                this.$store.getters.listForm(this.modalKey)['valid'] = val
            },

            isValidateForm(val) {

                if(val!=0) { 
                    this.validate(val); 
                    }
            },
            
            '$route.query' : {
            handler(val) {
                this.querys = val
                this.$store.dispatch('changeParamPage',{page:this.modalKey,item:'querys',value:val})
            }, deep:true           
        },

            activeTemplate(n) {
                this.selectedTemplate = n || false;
            },
            guidePageSelection(selection) {
                this.publishGuidePageContext(selection)
            }


        },

        methods : {
          recordPageView() {
            const user = this.$store.getters.currentUser || {}
            if (this._usageRecorded || this.isEmbedded || !user.profil_id || user.public !== false || Number(user.type) === 3) return
            if (this.hook && !['tabs', 'fromtable'].includes(this.hook)) return
            this.$nextTick(() => {
              if (this._isBeingDestroyed || this._isDestroyed) return
              if (this._stopUsageTracking) this._stopUsageTracking()
              this._usageViewId = this._usageViewId || usageViewId()
              this._stopUsageTracking = observePageUsage({
                element: this.$el, pageId: this.page, profilId: user.profil_id, actorType: user.type, viewId: this._usageViewId,
                canRecord: () => Number((this.$store.getters.currentUser || {}).type) !== 3 && !this.ModifTemplate && this.editTemplate === false && !this.findError,
                onRecorded: () => { this._usageRecorded = true },
              })
            })
          },
          publishGuidePageContext(selection = this.guidePageSelection) {
            const revision = this._guidePageContextRevision = (this._guidePageContextRevision || 0) + 1
            updateGuidePageContext(this.modalKey, { ...selection, ready: false })
            this.$nextTick(() => {
              if (this._isBeingDestroyed || this._isDestroyed || revision !== this._guidePageContextRevision) return
              updateGuidePageContext(this.modalKey, {
                ...selection,
                ready: selection.selected && !selection.editing && !selection.embedded,
              })
            })
          },
          editPageRights() {
            openRightsEditor({ id: this.page, target: 'page', root: 'interface' })
          },

          getFromAPI() {
          const request = this.isEmbedded && this.resolvedPage
            ? Promise.resolve({ data: { success: true, page: this.resolvedPage } })
            : this.API({type:'post', url:'page', params:{id : this.page, params : this.params, querys : this.querys }})
          request.then((resp) => {
                  if(this._isBeingDestroyed || this._isDestroyed) return

                  if(!resp.data.success) {
                      this.allowed = resp.data
                      this.findError = true;
                      return;
                  }

                  this.paramsPage = resp.data.page.displays.params
                  let ppa = resp.data.page.displays.parameters || {}
                  if(ppa.params) this.params = {...this.params, ...ppa.params}
                  if(ppa.query && Object.keys(ppa.query).length) {
                    this.querys = {...this.querys, ...ppa.query}

                  if (!this.isEmbedded && JSON.stringify(this.querys) !== JSON.stringify(this.$route.query)) this.$router.replace({
                    query: { ...this.$route.query, ...this.querys }
                    });                 
                }

                  this.$store.dispatch('changeParamPage',{page:this.modalKey,item:'params',value:this.params})
                  this.$store.dispatch('changeParamPage',{page:this.modalKey,item:'querys',value:this.querys})

                  //initialisation de l'array des conditons, poeut importe le type de page
                  this.$store.dispatch('initConditionForm',{page : this.modalKey})
                  if (this.typeform) {
                    this.initialiseForm().then((data) => {
                      if(this._isBeingDestroyed || this._isDestroyed) {
                        if(this.isEmbedded) disposeResourceContext(this.$store, this.modalKey)
                        return
                      }
                        if(!data.success) {
                            this.$toast.error(data.message)
                        }
                      this.processPageData(resp.data);
                    })
                  } else {
                    this.processPageData(resp.data);
                  }
  
                  
              }).catch(() => {
                this.findError = true
                this.allowed = { success: false, message: 'Cette page ne peut pas être chargée actuellement.' }
              })

          },

          getActionFromTemplate(datas) {
            if(datas.type=='validform') {
                
                this.validate(datas.value,datas.hook)
            }
          },

          processPageData(data) {
            this.variantPage = data.page.displays.variant;
            this.template = data.page.displays.template;
            //permet d'insérer les réponses de tous les modules appelés pour les répartir dans la page.
            //this.$store.dispatch('insertModuleDatas', { page: this.modalKey, modules: data.modules });
            // Publish the same selected object that is passed to the page renderer.
            this.selectedTemplate = this.activeTemplate || false;
            // Vérifie si une condition n'est pas remplie sur le template
            //this.verifyActiv();
          },


          recupTemplate(arr) {
                this.template.find(el => el.key == this.selectedTemplate.key).template = arr;
            },

            // Sauvegarde uniquement la construction de la variante affichée.
            async savePage(exitAfterSave = false) {
                if (this.savingTemplate) return false
                this.savingTemplate = true
                try {
                    const response = await this.API({type:'put', url:'savetemplate', params:{
                        id:this.page,
                        template:JSON.parse(JSON.stringify(this.template)),
                        variant:this.variantPage
                    }})
                    if (!response.data || response.data.success !== true) {
                        throw new Error(response.data && response.data.message || 'Impossible d’enregistrer le template.')
                    }
                    this.$toast.success('Template enregistré')
                    if (exitAfterSave) this.editTemplate = false
                    return true
                } catch (error) {
                    this.$toast.error(error.message || 'Impossible d’enregistrer le template.')
                    return false
                } finally {
                    this.savingTemplate = false
                }
            },

            //permet de gérer les actions du template, via listElem
            manageTemplate(elems) {
                if(elems.type=='delete' && confirm('Vous allez supprimer cette ce template, continuer ?')) {
                    //si on supprime le template qui est entrain d'etre modifié, on revient directement sur le template par défaut
                    if(elems.index === this.editTemplate) {
                       this.editTemplate = false
                       //this.verifyActiv()
                    }
                    this.template = this.template.filter((el,i) => i != elems.index);
                }
                if(elems.type=='build') {
                    this.editTemplate = elems.index
                    //this.verifyActiv()
                }
                if(elems.type=='insert') {
                    this.template.push({name:'nouveau template',key:'newtemp',template:[],'conditions':[]})
                }
                if(elems.type=='update') {
                    
                    this.indexTemplate = elems.index;
                    this.dialogTemplate = true
                }                
            },

            //ferme la modal de condition du template
            closeDial() {
                this.dialogTemplate = false
                this.indexTemplate = false
            },

            //permet de définir quel template est affiché en fonction des conditions sur la page
            /*
            verifyActiv() {
                var find = false;
                
                if(this.editTemplate!==false)  {

                    this.selectedTemplate = this.template[this.editTemplate];

                } else {
                    this.template.forEach((templ,i) => {
                        if(i!=0 && this.visuelConditions(templ.conditions).length && this.visuelConditions(templ.conditions).every(val => val === true)) {
                        find = templ;
                        
                    }
                    })
                    if(find) {
                        this.selectedTemplate = find;
                        console.log('template changé pour ',this.modalKey,'-',this.selectedTemplate.name)
                    }  else {
                        this.selectedTemplate = this.template[0];
                    }
                }

                //j'ai fais un return pour afficher le nom dans le DOM, MAIS aussi, si je met la fonction dans le dom, ca va etre réactif à chaque 
                //changement de variables.... bizarre..
                return this.selectedTemplate.name
            }, */

            //function pour la validationdu formulaire. est envoyé lors du click d'un bouton form dans le template (voir le watch)

            validate(typerec,hook) {

                this.$store.dispatch('textOverlay','enregistrement en cours')

                    this.validateForm({form:this.$refs['form-'+this.modalKey],page:this.page,modalKey:this.modalKey,validate:typerec,hook:hook,
                        ifNotValid:()=>{
                        this.$store.dispatch('changeParamForm',{page:this.modalKey,type:'validate',value:0}) 
                        },
                        callback:()=> {                       

                     }}) 
               
            },

            //si le type de page est un form on va loader les valeurs des champs. se lance dans getFromAPI()
            initialiseForm() {

                return new Promise((resolve) => {

                    this.initForm({modalKey:this.modalKey,params:this.params,typeform:this.typeform,page:this.page}).then((data) => {
                        
                        if(!data.success) {
                            resolve(data) 
                            return;
                        }
                        if(data.crud) {
                                this.showFormCrud.visu = true
                                this.showFormCrud.table = data.crud;
                                this.showFormCrud.id = this.params.id;
                        }  
                    resolve(data)                  
                    })
                
                })

            }


        },


        mounted() {
          this.publishGuidePageContext()
          this.getFromAPI()
        },

        beforeDestroy() {
          if(this._stopUsageTracking) this._stopUsageTracking()
          if(this._unregisterGuidePageContext) this._unregisterGuidePageContext()
          if(this.isEmbedded) disposeResourceContext(this.$store, this.modalKey)
          else this.$store.dispatch('removeSpecificPage', this.modalKey)
        },


        created() {
          this._unregisterGuidePageContext = registerGuidePageContext({
            instanceId: this.modalKey,
            modalKey: this.modalKey,
            parentModalKey: this.parentModalKey || null,
            pageId: this.page,
            modal: !!this.modal,
            primary: !this.independant && !this.hook,
            embedded: this.isEmbedded,
            element: () => this.$el,
          })
          this.$store.dispatch('initModal',{current:this.modalKey,parent:this.parentModalKey})
          this.$store.dispatch('initPage',{page:this.page,modalKey:this.modalKey,embedded:this.isEmbedded,
            metadata: this.isEmbedded ? { props: {page:this.page,typeform:this.typeform}, table:this.resolvedPage && this.resolvedPage.table || '', name:this.resolvedPage && this.resolvedPage.name || '', displayname:this.resolvedPage && this.resolvedPage.displays && this.resolvedPage.displays.displayname || '', parentform:this.resolvedPage && this.resolvedPage.parentform || '' } : undefined })
                         
                //récupération des params et querys en fonction de l'environement de la page
                
                var modal = this.$store.getters.modalShowParams({ type: 'current', val: this.parentModalKey })
                this.params = (this.modal && modal && modal.show) ? modal.params : this.$route.params   
                this.querys = this.$route.query || {}
                this.params = (this.customparams) ? this.customparams : this.params
                //intégration des params de la page
                this.$store.dispatch('changeParamPage',{page:this.modalKey,item:'params',value:this.params})
                this.$store.dispatch('changeParamPage',{page:this.modalKey,item:'querys',value:this.querys})

                if(!this.isEmbedded && !modal && !this.hook) this.$store.dispatch('current',this.modalKey)

        }


  }
</script>

<style>
.chat-page-host { position: relative; }
.page-header-tools { display: flex; align-items: center; gap: 8px; padding: 0 2px; }
.page-header-tools .chat-page-share { position: static; flex: 0 0 auto; margin-left: auto; }
.page-template-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  min-height: 24px;
  flex: 1;
  min-width: 0;
  margin: 0;
  font-size: 10px;
  line-height: 14px;
}
.page-template-toolbar .page-template-toolbar__switch {
  flex: 0 0 30px;
  max-width: 30px;
  transform: scale(0.8);
  transform-origin: left center;
}
.page-template-toolbar__switch .v-input--selection-controls__input {
  margin-right: 0;
}
.page-template-toolbar__variant {
  flex-shrink: 0;
  opacity: 0.65;
}
.page-template-toolbar__name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* Transition personnalisée */
.custom-fade-enter-active,
.custom-fade-leave-active {
  transition: opacity 0.5s ease-in-out; /* Durée de 500ms */
}

.custom-fade-enter,
.custom-fade-leave-to {
  opacity: 0;
}
</style>
